import { render, staticRenderFns } from "./AddRoute.vue?vue&type=template&id=2b4a2558&"
import script from "./AddRoute.vue?vue&type=script&lang=ts&"
export * from "./AddRoute.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports